import { translationSerializer } from '@/providers/serializers/translations/translations';
import { http } from '../http';

export class TranslationsAPI {

    private static INSTANCE = new TranslationsAPI();

    private namespace: string = 'api/nucleus/v2';

    private adminNamespace: string = 'api/admin/v1';

    static get instance() {
        return this.INSTANCE;
    }

    public fetchTranslationLabels(params = {}) {
        const endpoint = `${this.namespace}/lookups/translation/labels`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers, params).then((response) => {
            return translationSerializer.normalizeTranslations(response.data);
        });
    }

    public updateTranslationLabels(payload: any) {
        const endpoint = `${this.adminNamespace}/translation/labels`;
        const headers = http.getTokenHeaders();
        return http.post(endpoint, headers, payload).then((response) => {
            return response.status;
        });
    }

}

export const translationsAPI = TranslationsAPI.instance;

